module.exports = __webpack_public_path__ + "static/super-service-0e1daf23ba11e31b2db053bc14c2c5c0.gif";